<template>
  <div class="container-custom">
    <!-- Breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Where To Buy',
          to: {
            name: 'WhereToBuy',
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'WhereToBuyEdit',
            params: {
              id: $route.params.id,
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Where To Buy</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!--  -->
    <WhereToBuyCreateEdit></WhereToBuyCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import WhereToBuyCreateEdit from '@/views/H_WhereToBuy/c/WhereToBuyCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    WhereToBuyCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('buyChannel', ['buyChannel']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getBuyChannel(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('buyChannel', {
      getBuyChannel: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push({ name: 'WhereToBuy' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.buyChannel).then(() => {
          this.$router.push({ name: 'WhereToBuy' });
          this.clear();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
